var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdatedAt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1734335047461,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 15135,
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M857.6 0c-19.2 0-38.4 19.2-38.4 38.4v102.4c-192-166.4-486.4-147.2-659.2 38.4-185.6 198.4-172.8 505.6 25.6 684.8 198.4 185.6 505.6 172.8 684.8-25.6 12.8-12.8 12.8-32 0-44.8-12.8-12.8-32-12.8-44.8 0-160 172.8-422.4 179.2-595.2 19.2C57.6 652.8 51.2 390.4 211.2 217.6 352 64 601.6 44.8 774.4 185.6h-96c-19.2 0-38.4 19.2-38.4 38.4 0 12.8 19.2 32 38.4 32h166.4c25.6 0 51.2-25.6 51.2-57.6V38.4c0-19.2-19.2-38.4-38.4-38.4z",
    "p-id": 15136,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M614.4 185.6c-32-12.8-64-19.2-102.4-19.2C320 166.4 166.4 320 166.4 512S320 857.6 512 857.6c192 0 345.6-153.6 345.6-345.6 0-89.6-32-172.8-89.6-230.4h-108.8c-25.6 0-51.2-25.6-51.2-57.6 0-19.2 6.4-32 6.4-38.4zM492.8 294.4c25.6 0 51.2 19.2 51.2 44.8v160c0 6.4 0 12.8 6.4 12.8l96 57.6c25.6 6.4 38.4 38.4 25.6 57.6-12.8 25.6-38.4 32-64 25.6L460.8 576c-12.8-6.4-19.2-12.8-19.2-25.6V339.2c0-25.6 25.6-44.8 51.2-44.8z",
    "p-id": 15137,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdatedAt);
export default __webpack_public_path__ + "static/media/updated-at.984cec8734643cd5ca38d33e1491ff3c.svg";
export { ForwardRef as ReactComponent };